import {
  EDIT_SERIES,
  LOAD_SERIES,
  SET_SERIES_GENRE,
  SET_SERIES_NAME,
  SET_SERIES_PREMISE,
  SET_SERIES_THEME,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').Series} Series
 * @typedef {import('../index').DOMSelection} DOMSelection
 */

/**
 * @typedef SeriesUpdateValue
 * @property {Series[keyof Series]} value
 * @property {DOMSelection} [selection]
 */

/**
 * @typedef {Record<keyof Series, SeriesUpdateValue>} UpdateSeriesAttributes
 */

/**
 * @typedef {ReturnType<typeof editSeries> | ReturnType<typeof setSeriesName> | ReturnType<typeof setSeriesPremise> | ReturnType<typeof setSeriesGenre> | ReturnType<typeof setSeriesTheme> | ReturnType<typeof load>} SeriesActions
 */

// Deprecated!
/**
 * @param {Partial<UpdateSeriesAttributes>} attributes
 * @return {{ type: 'EDIT_SERIES', attributes: Partial<UpdateSeriesAttributes> }}
 */
export function editSeries(attributes) {
  return { type: EDIT_SERIES, attributes }
}

/**
 * @param {String} name
 * @param {DOMSelection} selection
 * @return {{ type: 'SET_SERIES_NAME', name: String, selection: DOMSelection }}
 */
export function setSeriesName(name, selection) {
  return { type: SET_SERIES_NAME, name, selection }
}

/**
 * @param {String} premise
 * @param {DOMSelection} selection
 * @return {{ type: 'SET_SERIES_PREMISE', premise: String, selection: DOMSelection }}
 */
export function setSeriesPremise(premise, selection) {
  return { type: SET_SERIES_PREMISE, premise, selection }
}

/**
 * @param {String} genre
 * @param {DOMSelection} selection
 * @return {{ type: 'SET_SERIES_GENRE', genre: String, selection: DOMSelection }}
 */
export function setSeriesGenre(genre, selection) {
  return { type: SET_SERIES_GENRE, genre, selection }
}

/**
 * @param {String} theme
 * @param {DOMSelection} selection
 * @return {{ type: 'SET_SERIES_THEME', theme: String, selection: DOMSelection }}
 */
export function setSeriesTheme(theme, selection) {
  return { type: SET_SERIES_THEME, theme, selection }
}

/**
 * @param {boolean} patching
 * @param {Series} series
 * @return {{ type: 'LOAD_SERIES', patching: boolean, series: Series }}
 */
export function load(patching, series) {
  return { type: LOAD_SERIES, patching, series }
}
